import { MODE } from "../types"

const initialState = {
	mode: localStorage.getItem("mode") ? localStorage.getItem("mode") : "light",
}

export default function (state = initialState, action) {
	switch (action.type) {
		case MODE:
			return {
				mode: action.payload,
			}
		default:
			return state
	}
}
